import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {
      memberId:''
    }, //个人信息
    goodsType: [], //商品分类
    openIdKey:'',//微信的OpenId
    loginInfo:{},
    token:'',
    
  },
  mutations: {
    setUserInfo(state, payload){
      state.userInfo = payload;
    },
    setGoodsType(state, payload) {
      state.goodsType = payload;
    },
    setOpenIdKey(state, payload) {
      state.openIdKey = payload;
    },
    setLoginInfo(state, payload){
      state.loginInfo = payload
      localStorage.setItem('vipLoginInfo',JSON.stringify(payload))
    },
    setToken(state, payload){
      state.token = payload
      localStorage.setItem('token',payload)
      axios.defaults.headers.common['Authorization'] = payload
    }
  },
  actions: {},
  modules: {},
});
